import { render, staticRenderFns } from "./finance-collection.vue?vue&type=template&id=9f1b56a0&scoped=true&"
import script from "./finance-collection.vue?vue&type=script&lang=js&"
export * from "./finance-collection.vue?vue&type=script&lang=js&"
import style0 from "./finance-collection.vue?vue&type=style&index=0&id=9f1b56a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1b56a0",
  null
  
)

export default component.exports